"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
exports.SearchBar = function (_a) {
    var _b = _a.q, q = _b === void 0 ? "" : _b, showSearch = _a.showSearch;
    return showSearch ? (react_1.default.createElement("div", { style: {
            width: "100%",
            height: "40px",
            borderRadius: "9999px",
            background: "#eaeffb"
        } },
        react_1.default.createElement(creator_ui_1.Flexbox, { as: "label", html: "#global-search", alignItems: "center", style: { width: "100%", height: "100%", cursor: "text" } },
            react_1.default.createElement("i", { className: "fa fa-search", style: { fontSize: 14, margin: "0 0 0 20px" } }),
            react_1.default.createElement("form", { action: "/search", method: "GET" },
                react_1.default.createElement("input", { id: "global-search", type: "text", name: "q", style: {
                        flex: 1,
                        outline: "none",
                        border: "none",
                        background: "transparent",
                        padding: "0 0 0 20px"
                    }, defaultValue: q, placeholder: "Search", onKeyUp: function (e) {
                        var value = e.currentTarget.value;
                        if (e.key === "Enter") {
                            console.log({ value: value });
                        }
                    } }))))) : null;
};
